import React from 'react'
import styled from "styled-components";
import { Spinner } from '@etiquette-ui/misc';
import { LIGHT, LIGHT_GRAY } from 'resources/Colors';

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
`;

const Loader = ({isLoading, children}) => isLoading ? (
    <Center>
      <Spinner
        style={{
          '--color': LIGHT,
          '--bg': LIGHT_GRAY,
          "--size": "50px",
        }}
      />
    </Center>
) : <> {children} </>


export default Loader
